import { RecursiveStringifyEnums } from './buildDistro';
import { computeNextVersionFromVersion, getIsOTAPlatform } from './../helpers';
import { AppPlatform, ReleaseOverview, ReleaseStatistics, ReleaseType, StatisticType } from '../types';

const generateRawStats: (platform: AppPlatform) => RecursiveStringifyEnums<ReleaseStatistics[]> = (_) => {
    return [
        {
            id: '3.87.0',
            completedAtOrReleasedAtTimestamp: 1635812404,
            statistics: [
                {
                    value: 100,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 707,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 67,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 0,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -59,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 54,
                    type: 'CommitCount',
                    average: 57,
                    change: -53,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 5,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -19,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 15,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 24,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 24,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 97497,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -9307138,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 81266,
                    type: 'WaitingForReviewDuration',
                    average: 54431,
                    change: 26835,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 8567,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: 5220,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 813,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7308,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 825,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13653,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 62,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6345,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.87.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0,
                    userAdoption: 0,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.87.0+232',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.87.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0,
                    userAdoption: 0,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.87.0+232',
                },
                {
                    version: '3.87.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0,
                    userAdoption: 0,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.87.0+230',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.88.0',
            completedAtOrReleasedAtTimestamp: 1635977111,
            statistics: [
                {
                    value: 60,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: -40,
                    changeStatus: 'Bad',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 653,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 13,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 0,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -59,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 52,
                    type: 'CommitCount',
                    average: 57,
                    change: -55,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 3,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -21,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 15,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 24,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 24,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 29053,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -9375582,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 637,
                    type: 'WaitingForReviewDuration',
                    average: 54431,
                    change: -53794,
                    changeStatus: 'Good',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 708,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: -2639,
                    changeStatus: 'Good',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 811,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7310,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 822,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13656,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 61,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6346,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.88.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.14668133480014667,
                    userAdoption: 0.1448225923244026,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.88.0+238',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.88.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.14668133480014667,
                    userAdoption: 0.1448225923244026,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.88.0+238',
                },
                {
                    version: '3.88.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0,
                    userAdoption: 0,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.88.0+235',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.89.0',
            completedAtOrReleasedAtTimestamp: 1636660764,
            statistics: [
                {
                    value: 100,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 677,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 37,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 0,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -59,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 52,
                    type: 'CommitCount',
                    average: 57,
                    change: -55,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 9,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -15,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 15,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 24,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 24,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 681291,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -8723344,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 74537,
                    type: 'WaitingForReviewDuration',
                    average: 54431,
                    change: 20106,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 4292,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: 945,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 811,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7310,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 822,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13656,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 61,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6346,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 5,
                    type: 'FixRequestsCount',
                    average: 3,
                    change: 2,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.89.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.03667033370003667,
                    userAdoption: 0.0724112961622013,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.89.0+248',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.89.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.03667033370003667,
                    userAdoption: 0.0724112961622013,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.89.0+248',
                },
                {
                    version: '3.89.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0,
                    userAdoption: 0,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.89.0+247',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.90.0',
            completedAtOrReleasedAtTimestamp: 1636826192,
            statistics: [
                {
                    value: 100,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 654,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 14,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 0,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -59,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 53,
                    type: 'CommitCount',
                    average: 57,
                    change: -54,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 2,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -22,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 15,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 24,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 24,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 190802,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -9213833,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 57091,
                    type: 'WaitingForReviewDuration',
                    average: 54431,
                    change: 2660,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 4674,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: 1327,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 812,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7309,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 824,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13654,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 62,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6345,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.90.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.037216226274655755,
                    userAdoption: 0.07374631268436578,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.90.0+250',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.90.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.037216226274655755,
                    userAdoption: 0.07374631268436578,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.90.0+250',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.91.0',
            completedAtOrReleasedAtTimestamp: 1637596528,
            statistics: [
                {
                    value: 75,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: -25,
                    changeStatus: 'Bad',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 619,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: -21,
                    changeStatus: 'Good',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 3,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -56,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 53,
                    type: 'CommitCount',
                    average: 57,
                    change: -54,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 3,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -21,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 15,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 24,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 24,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 742921,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -8661714,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 333882,
                    type: 'WaitingForReviewDuration',
                    average: 54431,
                    change: 279451,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 6479,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: 3132,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 811,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7310,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 822,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13656,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 61,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6346,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 5,
                    type: 'FixRequestsCount',
                    average: 3,
                    change: +2,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.91.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.021052631578947368,
                    userAdoption: 0.04319654427645788,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.91.0+254',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.91.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.021052631578947368,
                    userAdoption: 0.04319654427645788,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.91.0+254',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.92.0',
            completedAtOrReleasedAtTimestamp: 1637680770,
            statistics: [
                {
                    value: 100,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 668,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 28,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 4,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -55,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 54,
                    type: 'CommitCount',
                    average: 57,
                    change: -53,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 2,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -22,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 15,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 24,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 24,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 189092,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -9215543,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 4321,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: 974,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 829,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7292,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 841,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13637,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 62,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6345,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.92.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 1.3263157894736841,
                    userAdoption: 1.5550755939524838,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.92.0+256',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.92.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 1.3263157894736841,
                    userAdoption: 1.5550755939524838,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.92.0+256',
                },
                {
                    version: '3.92.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0,
                    userAdoption: 0,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.92.0+255',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.93.0',
            completedAtOrReleasedAtTimestamp: 1639581569,
            statistics: [
                {
                    value: 70,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: -30,
                    changeStatus: 'Bad',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 650,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 10,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 2,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -57,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 52,
                    type: 'CommitCount',
                    average: 57,
                    change: -55,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 12,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -12,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 15,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 24,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 24,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 5971692,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -3432943,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 811,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7310,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 822,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13656,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 61,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6346,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 5,
                    type: 'FixRequestsCount',
                    average: 3,
                    change: +2,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.93.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 1.6421052631578947,
                    userAdoption: 1.9438444924406046,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.93.0+273',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.93.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 1.6421052631578947,
                    userAdoption: 1.9438444924406046,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.93.0+273',
                },
                {
                    version: '3.93.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0,
                    userAdoption: 0,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.93.0+261',
                },
                {
                    version: '3.93.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0,
                    userAdoption: 0,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.93.0+258',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.94.0',
            completedAtOrReleasedAtTimestamp: 1645718224,
            statistics: [
                {
                    value: 100,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 706,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 66,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 3,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -56,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 53,
                    type: 'CommitCount',
                    average: 57,
                    change: -54,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 4,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -20,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 164972,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -9239663,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 22273,
                    type: 'WaitingForReviewDuration',
                    average: 54431,
                    change: -32158,
                    changeStatus: 'Good',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 1667,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: -1680,
                    changeStatus: 'Good',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 819,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7302,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 832,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13646,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 63,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6344,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.94.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.1894736842105263,
                    userAdoption: 0.17278617710583152,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.94.0+277',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.94.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.1894736842105263,
                    userAdoption: 0.17278617710583152,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.94.0+277',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.95.0',
            completedAtOrReleasedAtTimestamp: 1646172023,
            statistics: [
                {
                    value: 80,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: -20,
                    changeStatus: 'Bad',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 646,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 6,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 3,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -56,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 53,
                    type: 'CommitCount',
                    average: 57,
                    change: -54,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 4,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -20,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 446658,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -8957977,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 53842,
                    type: 'WaitingForReviewDuration',
                    average: 54431,
                    change: -589,
                    changeStatus: 'Good',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 12600,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: 9253,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 811,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7310,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 1522,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13656,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 61,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6346,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 5,
                    type: 'FixRequestsCount',
                    average: 3,
                    change: +2,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [
                {
                    version: '3.95.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.042105263157894736,
                    userAdoption: 0.04319654427645788,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.95.0+281',
                },
            ],
            allBetaBuildsStabilityInfo: [
                {
                    version: '3.95.0',
                    environmentName: '',
                    integrationId: 'sentry',
                    sessionStability: 100,
                    userStability: 100,
                    sessionAdoption: 0.042105263157894736,
                    userAdoption: 0.04319654427645788,
                    adoptionPeriodString: null,
                    topNewStabilityIssues: [],
                    topStabilityIssues: [],
                    topNewStabilityIssuesNonFatal: [],
                    topStabilityIssuesNonFatal: [],
                    url: 'https://sentry.io/organizations/tab-mp/releases/com.bring10.tab@3.95.0+281',
                },
            ],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.96.0',
            completedAtOrReleasedAtTimestamp: 1646323163,
            statistics: [
                {
                    value: 50,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: -50,
                    changeStatus: 'Bad',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 626,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: -14,
                    changeStatus: 'Good',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 7,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -52,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 57,
                    type: 'CommitCount',
                    average: 57,
                    change: -50,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 1,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -23,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 0,
                    change: 15,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 24,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 0,
                    change: 24,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 157462,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -9247173,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 4477,
                    type: 'WaitingForReviewDuration',
                    average: 54431,
                    change: -49954,
                    changeStatus: 'Good',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 8400,
                    type: 'InReviewDuration',
                    average: 3347,
                    change: 5053,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 811,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: -7310,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 1522,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: -13656,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 61,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: -6346,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 5,
                    type: 'FixRequestsCount',
                    average: 3,
                    change: +2,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
            ],
            allBuildsStabilityInfo: [],
            allBetaBuildsStabilityInfo: [],
            totalAutomationsPerformedCount: 0,
            estimatedAutomationsTimeSaved: 0,
            estimatedAutomationsCostSaving: 0,
        },
        {
            id: '3.97.0',
            completedAtOrReleasedAtTimestamp: 1650470362,
            statistics: [
                {
                    value: 52,
                    type: 'CIWorkflowSuccessPercent',
                    average: 100,
                    change: -48,
                    changeStatus: 'Bad',
                    unit: 'percent',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 758,
                    type: 'CIAverageBuildTime',
                    average: 640,
                    change: 118,
                    changeStatus: 'Bad',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 14,
                    type: 'ItemsCompleted',
                    average: 59,
                    change: -45,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 65,
                    type: 'CommitCount',
                    average: 57,
                    change: -42,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 11,
                    type: 'AppStoreBuildCount',
                    average: 24,
                    change: -13,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 15,
                    type: 'AppStoreBuildBundleDownloadSize',
                    average: 15,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 25,
                    type: 'AppStoreBuildBundleInstallSize',
                    average: 24,
                    change: 1,
                    changeStatus: 'Bad',
                    unit: 'megabytes',
                    additionalData: null,
                    category: 'build',
                },
                {
                    value: 9017943,
                    type: 'ReleaseDuration',
                    average: 9404635,
                    change: -386692,
                    changeStatus: 'Neutral',
                    unit: 'seconds',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 7640,
                    type: 'LinesOfCodeAdded',
                    average: 7371,
                    change: 269,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 16587,
                    type: 'LinesOfCodeChanged',
                    average: 13778,
                    change: 2109,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 8247,
                    type: 'LinesOfCodeDeleted',
                    average: 6407,
                    change: 1840,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: null,
                    category: 'work',
                },
                {
                    value: 0.4560669456066946,
                    type: 'AverageEventsPerDailyActiveUser',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'billsplit_image_success',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 0.34081590039274345,
                    type: 'AverageEventsPerSession',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'billsplit_image_success',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 0.5962343096234309,
                    type: 'AverageEventsPerDailyActiveUser',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'billsplit_success',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 0.4455620716143664,
                    type: 'AverageEventsPerSession',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'billsplit_success',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 4.812761506276151,
                    type: 'AverageEventsPerDailyActiveUser',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'view homeView',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 3.596545774557369,
                    type: 'AverageEventsPerSession',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'view homeView',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 0.6098326359832636,
                    type: 'AverageEventsPerDailyActiveUser',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'do_billsplit',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 0.4557240135985538,
                    type: 'AverageEventsPerSession',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'do_billsplit',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 2.6150627615062763,
                    type: 'AverageEventsPerDailyActiveUser',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'view cameraView',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 1.9542196123437123,
                    type: 'AverageEventsPerSession',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'view cameraView',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 0.3263598326359833,
                    type: 'AverageEventsPerDailyActiveUser',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'did_select_from_camera_roll',
                    },
                    category: 'stabilityAndHealth',
                },
                {
                    value: 0.24388660762049533,
                    type: 'AverageEventsPerSession',
                    average: 0,
                    change: 0,
                    changeStatus: 'Neutral',
                    unit: 'count',
                    additionalData: {
                        eventName: 'did_select_from_camera_roll',
                    },
                    category: 'stabilityAndHealth',
                },
            ],
            allBuildsStabilityInfo: [],
            allBetaBuildsStabilityInfo: [],
            totalAutomationsPerformedCount: 36,
            estimatedAutomationsTimeSaved: 22770,
            estimatedAutomationsCostSaving: 53904,
        },
    ];
};

export const generateReleaseOverview: (args: {
    kickOffDate?: string;
    submitDate?: string;
    releaseDate?: string;
    targetKickoffDate?: string;
    targetSubmitDate?: string;
    targetReleaseDate?: string;
}) => ReleaseOverview = ({
    kickOffDate,
    submitDate,
    releaseDate,
    targetSubmitDate,
    targetKickoffDate,
    targetReleaseDate,
}) => {
    const releaseOverview: ReleaseOverview = {
        storeRejectedOn: null,
        devRejectedOn: null,
        isKickedOff: kickOffDate !== undefined,
        isSubmitted: submitDate !== undefined,
        isReleased: releaseDate !== undefined,
        kickedOffAt: kickOffDate,
        submittedAt: submitDate,
        targetKickoffDate: kickOffDate ?? targetKickoffDate,
        targetSubmitDate: submitDate ?? targetSubmitDate,
        targetReleaseDate: releaseDate ?? targetReleaseDate,
    };

    return releaseOverview;
};

export const generateReleaseStatsHistory: (args: {
    version?: string;
    platform?: AppPlatform;
    isCompletedRelease?: boolean;
}) => ReleaseStatistics[] = ({ version, platform, isCompletedRelease } = {}) => {
    const rawStats = generateRawStats(platform!) as ReleaseStatistics[];
    const offset = rawStats.length - 2; // hardcoded to have 2 next releases

    let currentVersion = '0.0.0';

    const disallowedStatTypes =
        getIsOTAPlatform(platform!) ?
            [
                StatisticType.AdoptionRate,
                StatisticType.AppStoreBuildBundleDownloadSize,
                StatisticType.AppStoreBuildBundleInstallSize,
                StatisticType.InReviewDuration,
                StatisticType.WaitingForReviewDuration,
                StatisticType.AppStoreBuildCount,
            ]
        :   [];

    if (!isCompletedRelease) {
        if (!disallowedStatTypes.includes(StatisticType.InReviewDuration)) {
            disallowedStatTypes.push(StatisticType.InReviewDuration);
        }
        if (!disallowedStatTypes.includes(StatisticType.WaitingForReviewDuration)) {
            disallowedStatTypes.push(StatisticType.WaitingForReviewDuration);
        }
    }

    return rawStats
        .map((stat, index) => {
            const id = computeNextVersionFromVersion(currentVersion, ReleaseType.Point);

            currentVersion = id;

            if (index === offset - 1) {
                currentVersion = version ?? currentVersion;
            }

            return {
                ...stat,
                id: currentVersion,
            };
        })
        .map((releaseStats) => {
            return {
                ...releaseStats,
                statistics: releaseStats.statistics.filter((stat) => !disallowedStatTypes.includes(stat.type)),
            };
        });
};
